import React from 'react';
import Chart from 'react-apexcharts';
import Moment from 'moment';

export default class Forms extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            options: {
                plotOptions: {
                    heatmap: {
                      distributed: true
                    }
                  }
              },
              dataLabels: {
                enabled: false
            },
              series: [{
                name: 'Kitchen',
                data: this.generateData(20, {
                  min: 0,
                  max: 2000
                }),
                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 400,
                        name: 'low',
                      },
                      {
                        from: 401,
                        to: 800,
                        name: 'medium',
                      },
                      {
                        from: 801,
                        to: 1400,
                        name: 'high',
                      },
                      {
                        from: 1401,
                        to: 2000,
                        name: 'extreme',
                      }
                    ]
                  }                
              },
              {
                name: 'Admin',
                data: this.generateData(20, {
                  min: 0,
                  max: 100
                }),
                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 10,
                        name: 'low',
                      },
                      {
                        from: 11,
                        to: 30,
                        name: 'medium',
                      },
                      {
                        from: 30,
                        to: 70,
                        name: 'high',
                      },
                      {
                        from: 71,
                        to: 100,
                        name: 'extreme',
                      }
                    ]
                  }                
              },
              {
                name: 'Operations',
                data: this.generateData(20, {
                  min: 0,
                  max: 20
                }),
                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 2,
                        name: 'low',
                      },
                      {
                        from: 3,
                        to: 7,
                        name: 'medium',
                      },
                      {
                        from: 8,
                        to: 15,
                        name: 'high',
                      },
                      {
                        from: 16,
                        to: 20,
                        name: 'extreme',
                      }
                    ]
                  },
              },
              {
                name: 'Maintenance',
                data: this.generateData(20, {
                  min: 0,
                  max: 20
                }),
                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 2,
                        name: 'low',
                      },
                      {
                        from: 3,
                        to: 7,
                        name: 'medium',
                      },
                      {
                        from: 8,
                        to: 15,
                        name: 'high',
                      },
                      {
                        from: 16,
                        to: 20,
                        name: 'extreme',
                      }
                    ]
                  },
              },
              {
                name: 'IT Department',
                data: this.generateData(20, {
                  min: 0,
                  max: 20
                }),
                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 2,
                        name: 'low',
                      },
                      {
                        from: 3,
                        to: 7,
                        name: 'medium',
                      },
                      {
                        from: 8,
                        to: 15,
                        name: 'high',
                      },
                      {
                        from: 16,
                        to: 20,
                        name: 'extreme',
                      }
                    ]
                  },
              },
              {
                name: 'Human Resources',
                data: this.generateData(20, {
                  min: 0,
                  max: 20
                }),
                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 2,
                        name: 'low',
                      },
                      {
                        from: 3,
                        to: 7,
                        name: 'medium',
                      },
                      {
                        from: 8,
                        to: 15,
                        name: 'high',
                      },
                      {
                        from: 16,
                        to: 20,
                        name: 'extreme',
                      }
                    ]
                  },
              }                                    
            ]            
        }
    }

    generateData = (count, yrange) => {
        var i = 0;
        var series = [];
        while (i < count) {
          var x = Moment().add(i, "days");
          var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
  
          series.push({
            x: x.format("MMM Do"),
            y: y
          });
          i++;
        }
        return series;
      }


    render() {

        return (
            <div className="guide-page">
                <h3 className="guide-title">Heatmap</h3>            
                <Chart type="heatmap" options={this.state.options} series={this.state.series} width={1000} height={300} />
            </div>
        );
    }
}
